export default function DanceExplosion() {
	return (
		<div className="px-6 sm:px-8">
			<div className="mx-auto max-w-2xl pt-4 text-center">
				<h2 className="text-2xl font-bold tracking-tight text-white sm:text-4xl">
					Dance Explosion
				</h2>
				<p className="text-[#f9c04d]">(Ages 7-9)</p>
				<p className="mt-6 text-sm font-bold text-stone-300 sm:text-base">
					With six styles of dance offered, Ballet, Tap, Jazz, Lyrical, Musical
					Theatre & Hip Hop, your dancer can choose one class or all six!
					Dancers will build a great foundation for their future in dance, all
					the while building their confidence and experiencing the joy dance
					brings.
				</p>
			</div>
			<div className="mt-8 border-t border-stone-600 font-bold">
				<dl className="divide-y divide-stone-600 border-b border-stone-600">
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Musical Theatre</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Tuesdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">4:45-5:45pm</div>
							</div>
						</dd>
					</div>
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Jazz</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Tuesdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">5:45-6:45pm</div>
							</div>
						</dd>
					</div>
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Lyrical</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Tuesdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">6:45-7:30pm</div>
							</div>
						</dd>
					</div>
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Ballet</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Thursdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">4:45-5:45pm</div>
							</div>
						</dd>
					</div>
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Tap</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Thursdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">5:45-6:45pm</div>
							</div>
						</dd>
					</div>
					<div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
						<dt className="text-sm text-stone-50">Hip Hop</dt>
						<dd className="col-span-1 sm:col-span-2">
							<div className="grid grid-cols-2 text-sm text-stone-100">
								<div className="justify-center sm:grid">
									<div className="flex items-center gap-2">
										Thursdays
										<span className="inline-grid text-[#f9c04d]">**</span>
									</div>
								</div>
								<div className="grid justify-end">6:45-7:30pm</div>
							</div>
						</dd>
					</div>
				</dl>
				<div className="mx-auto max-w-xl space-y-4 pt-12 text-center">
					<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
						<div>
							<span className="text-[#f9c04d]">** </span>Tuesdays - July 7, 14,
							21, 28, August 4
						</div>

						<div>
							<span className="text-[#f9c04d]">** </span>Thursdays - July 9, 16,
							23, 30, August 6
						</div>
					</div>
					<div className="space-y-2 rounded-lg border border-[#f9c04d] p-4 text-xs text-stone-100 sm:text-sm">
						<div className="underline">Drop in fee:</div>
						<div className="ml-4">
							<div>Ballet, Tap, Musical Theatre, Jazz: $22</div>
							<div>Hip Hop, Lyrical: $18</div>
						</div>
						<div className="mt-4 border-t border-stone-600 pt-4 underline">
							Five week session:
						</div>
						<div className="ml-4">
							<div>Ballet, Tap, Musical Theatre, Jazz: $100</div>
							<div>Hip Hop, Lyrical: $85</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
